import React from "react";
import { useTranslation } from "react-i18next";
import { Pagination } from '@uifabric/experiments'
import { Dropdown } from '@fluentui/react/lib/Dropdown';
import { setGlobalListPageSize } from "../../../common/Helpers";

export default function ListPagination(props) {
    const { t } = useTranslation();

    const inputParam_ListData = props.data !== null && props.data !== undefined ? props.data : null;
    const inputParam_SetterListData = props.setData !== null && props.setData !== undefined ? props.setData : null;

    const inputParam_ListLocalStoragePageSizeVariableName = props.listLocalStoragePageSizeVariableName !== undefined && props.listLocalStoragePageSizeVariableName !== null ? props.listLocalStoragePageSizeVariableName : null;

    const onPageChange = async (_pageNumber) => {
        const results = [];

        inputParam_ListData.filters.forEach(element => {
            for(let i = 0; i < inputParam_ListData.data.length; i++) {
                let key = Object.keys(inputParam_ListData.data[i]).map(key => inputParam_ListData.data[i][key]).join('|');

                if(key.toString().toLowerCase().indexOf(element.value.toString().toLowerCase()) !== -1) {
                    results.push(inputParam_ListData.data[i]);
                }
            } 
        });

        inputParam_SetterListData && inputParam_SetterListData(prevState => ({
            ...prevState,
            pageNumber: (_pageNumber + 1),
            fireUpdate: true,
            //data: (inputParam_ListData.filters.length > 0) ?  paginate(results, _pageNumber, inputParam_ListData.pageSize) : paginate(inputParam_ListData.data, _pageNumber, inputParam_ListData.pageSize)
        }));
    }
    
    const handleChangePageSize = async (event, option) => {
        const _pageSize = setGlobalListPageSize(inputParam_ListLocalStoragePageSizeVariableName, parseInt(option.key));

        inputParam_SetterListData && inputParam_SetterListData(prevState => ({
            ...prevState,
            //data: inputParam_ListData.data.slice(0, _pageSize),
            pageSize: _pageSize,
            totalPages: Math.ceil(inputParam_ListData.data.length / _pageSize),
            pageNumber: 1,
            fireUpdate: true,
        }));
    }

    return (
        <>
            {(inputParam_ListData && inputParam_ListData.data) &&
                <div>
                    <div className="d-flex" style={{ zIndex: 0,
                        backgroundColor: "rgb(255, 255, 255)",
                        height: "37px"}} >
                        <div className="text-nowrap">
                            <Pagination
                                selectedPageIndex={ inputParam_ListData.pageNumber - 1}
                                pageCount={ inputParam_ListData.totalPages}
                                itemsPerPage={ inputParam_ListData.pageSize}
                                totalItemCount={ inputParam_ListData.totalRecords}
                                onPageChange={onPageChange}
                                firstPageIconProps={{ iconName: 'DoubleChevronLeft' }}
                                previousPageIconProps={{ iconName: 'ChevronLeft' }}
                                nextPageIconProps={{ iconName: 'ChevronRight' }}
                                lastPageIconProps={{ iconName: 'DoubleChevronRight' }}
                                styles={{comboBox:{ marginTop: "-7px" }}}
                            />
                        </div>
                        <div className="pt-1 d-flex">
                            <div className="ps-1 pe-1">{t('data-lang-lbl-rows')}</div>
                            <div>
                                <Dropdown 
                                    placeholder={ inputParam_ListData.pageSize}
                                    options={[
                                        { key: '1', text: '1' },
                                        { key: '2', text: '2' },
                                        { key: '5', text: '5' },
                                        { key: '10', text: '10' },
                                        { key: '25', text: '25' },
                                        { key: '50', text: '50' },
                                    ]}
                                    styles={{ dropdown: { width: 100, marginTop: "-4px" }}}
                                    onChange={handleChangePageSize}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    ); 
}